import { computed, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../../shared/store/common/component-store-v2.factory';
import { FolderRiskStatusObject } from '@libs/types/src/services/object-type/folder/folder-risk-status.object';

@Injectable()
export class RiskyClientsWidgetStore extends ComponentStoreV2Factory {
    items = computed<FolderRiskStatusObject[]>(() => this.data.getFolderRiskStatuses()?.items || []);
}
